export default __webpack_public_path__ + "static/media/DiDa-logo1.ac1e1bc6.png";